module.exports = __webpack_public_path__ + "static/w31-colorful-d59957d27a682f0930e295634e57f2d4.webp";